import { useQuery } from '@tanstack/react-query'
import { fetchLastCompletedElection } from '@/services/elections'

export function useLastCompletedElection(nationId: string | undefined) {
  const query = useQuery({
    queryKey: ['elections', 'lastCompleted', nationId],
    queryFn: () => fetchLastCompletedElection(nationId!),
    enabled: !!nationId,
  })

  return {
    election: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}
